import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=23326144&scoped=true"
import script from "./ForgotPassword.ts?vue&type=script&lang=ts&external"
export * from "./ForgotPassword.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23326144",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23326144')) {
      api.createRecord('23326144', component.options)
    } else {
      api.reload('23326144', component.options)
    }
    module.hot.accept("./ForgotPassword.vue?vue&type=template&id=23326144&scoped=true", function () {
      api.rerender('23326144', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Auth/pages/ForgotPassword/ForgotPassword.vue"
export default component.exports